import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;

export default function ManagementMakeupRequests() {
  const [pending, setPending] = useState([]);
  const [archive, setArchive] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAll = () => {
    setIsLoading(true);
    Promise.all([
      axios.get(`${API_URL}/Custom/GetDepartmentMakeupRequests`),
      axios.get(`${API_URL}/Custom/GetArchivedMakeupRequests`),
    ])
      .then(([{ data: p }, { data: a }]) => {
        setPending(p);
        setArchive(a);
      })
      .catch(() => {
        Swal.fire({
          title: 'Hata',
          text: 'Talepler yüklenirken hata oluştu.',
          icon: 'error',
        });
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const handleDecision = (request, approve) => {
    const action = approve ? 'Onayla' : 'Reddet';
    const stageLabel = request.stage === 'dean' ? 'Dekanlık onayı' : 'Bölüm onayı';
    Swal.fire({
      title: `${stageLabel}: ${action}. Emin misiniz?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: action,
      cancelButtonText: 'Vazgeç',
    }).then((result) => {
      if (!result.isConfirmed) return;
      axios
        .post(`${API_URL}/Custom/ManageMakeupRequest`, { requestId: request.id, approve })
        .then(() => {
          Swal.fire({
            title: 'Başarılı',
            text: `Talep ${approve ? 'onaylandı' : 'reddedildi'}.`,
            icon: 'success',
          });
          fetchAll();
        })
        .catch(() => {
          Swal.fire({
            title: 'Hata',
            text: 'İşlem sırasında bir hata oluştu.',
            icon: 'error',
          });
        });
    });
  };

  if (isLoading) return <div>Yükleniyor...</div>;

  return (
    <div className='container my-4'>
      <h4>Bekleyen Telafi Talepleri</h4>
      {pending.length === 0 ? (
        <p>Bekleyen talep yok.</p>
      ) : (
        <table className='table table-striped mt-3'>
          <thead>
            <tr>
              <th>#</th>
              <th>Ders</th>
              <th>Tarih</th>
              <th>Saat</th>
              <th>Sınıf</th>
              <th>Talep Eden</th>
              <th>Gerekçe</th>
              <th>Kanıt</th>
              <th>Aşama</th>
              <th>Bölüm</th>
              <th>Dekanlık</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {pending.map((r) => (
              <tr key={r.id}>
                <td>{r.id}</td>
                <td>{r.courseName}</td>
                <td>{r.date}</td>
                <td>
                  {r.startTime.substring(0, 5)} - {r.endTime.substring(0, 5)}
                </td>
                <td>{r.classroomName}</td>
                <td>{r.requestedBy}</td>
                <td style={{ whiteSpace: 'pre-wrap' }}>{r.reason}</td>
                <td>
                  {r.evidencePath && (
                    <a
                      href={`${API_URL.slice(0, -3)}${r.evidencePath}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='btn btn-sm btn-outline-primary'
                    >
                      İndir
                    </a>
                  )}
                </td>
                <td>{r.stage === 'dean' ? 'Dekanlık onayı' : 'Bölüm onayı'}</td>
                <td>{r.departmentApproval === true ? 'Onaylandı' : 'Beklemede'}</td>
                <td>{r.deanApproval === true ? 'Onaylandı' : r.deanApproval === false ? 'Reddedildi' : 'Beklemede'}</td>
                <td>
                  <button
                    className='btn btn-sm btn-success me-2'
                    onClick={() => handleDecision(r, true)}
                  >
                    Onayla
                  </button>
                  <button
                    className='btn btn-sm btn-danger'
                    onClick={() => handleDecision(r, false)}
                  >
                    Reddet
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <hr />
      <h4>Geçmiş Talepler</h4>
      {archive.length === 0 ? (
        <p>Arşivde talep yok.</p>
      ) : (
        <table className='table table-striped mt-3'>
          <thead>
            <tr>
              <th>#</th>
              <th>Ders</th>
              <th>Tarih</th>
              <th>Saat</th>
              <th>Sınıf</th>
              <th>Talep Eden</th>
              <th>Gerekçe</th>
              <th>Kanıt</th>
              <th>Durum</th>
              <th>Bölüm</th>
              <th>Dekanlık</th>
            </tr>
          </thead>
          <tbody>
            {archive.map((r) => (
              <tr key={r.id}>
                <td>{r.id}</td>
                <td>{r.courseName}</td>
                <td>{r.date}</td>
                <td>
                  {r.startTime.substring(0, 5)} - {r.endTime.substring(0, 5)}
                </td>
                <td>{r.classroomName}</td>
                <td>{r.requestedBy}</td>
                <td style={{ whiteSpace: 'pre-wrap' }}>{r.reason}</td>
                <td>
                  {r.evidencePath && (
                    <a
                      href={`${API_URL.slice(0, -3)}${r.evidencePath}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='btn btn-sm btn-outline-primary'
                    >
                      İndir
                    </a>
                  )}
                </td>
                <td>{r.status}</td>
                <td>{r.departmentStatus}</td>
                <td>{r.deanStatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
